import yz from '../modules/yz.js'
export default [
    // 人脸认证结果-合同
    { path: '/yz/faceAuthResults/:faceType', name: 'YzFaceAuthResults', component: yz.faceAuthResults, meta: { single: true, title: '用户实名认证' } },
    // 签章
    { path: '/yz/signature.xhtml', name: 'settlementSheet', component: yz.signature },
    // 融资信息收集
    { path: '/yz/form/financingIntention.xhtml', name: 'financingInformationCollection', component: yz.financingIntention, meta: { title: '云租融资意向' } },
    // 闲置设备发布
    { path: '/yz/form/idleEquipment.xhtml', name: 'idleEquipmentDemandRelease', component: yz.idleEquipment, meta: { title: '云租闲置设备需求发布' } },
    // 表单提交结果
    { path: '/yz/form/result.xhtml', name: 'formResults', component: yz.formResults, meta: { title: '' } },
    //告警中心
    { path: '/yz/warningCenter.xhtml', name: 'warningCenter', component: yz.warningCenter, meta: { title: '告警信息' } },
    //告警中心-视频回放
    { path: '/yz/video.xhtml', name: 'video', component: yz.video, meta: { title: '视频回放' } },
    //pdf查看
    { path: '/yz/pdfViewer/:fileType', name: 'pdfViewer', component: yz.pdfViewer, meta: { title: '' } },
    // 运营管理平台-登录
    { path: '/yz/payRecord/login.xhtml', name: 'payRecordLogin', component: yz.payRecordLogin, meta: { title: '' } },
    // 运营管理平台-减肥记录列表
    { path: '/yz/payRecord/list.xhtml', name: 'payRecordList', component: yz.payRecordList, meta: { title: '缴费记录' } },
    // 运营管理平台-详情
    { path: '/yz/payRecord/detail.xhtml', name: 'payRecordDetail', component: yz.payRecordDetail, meta: { title: '缴费记录详情' } },
    // 
    { path: '/yz/payRecord/pdf-viewer.xhtml', name: 'payRecordDetailPDF', component: yz.payRecordDetailPDF, meta: { title: '订阅协议' } },

] 